import React from 'react'
import styles from '../registration.module.scss'
import FormInputGroup from 'components/generic/FormInputGroup'
import InfoBox from 'components/generic/InfoBox'
import InputWTN from 'components/generic/InputWTN'
import { useFormLabels } from 'forms/common/translations'
import { FormikNames } from 'types/forms/formik-names'
import cx from 'classnames'
import { ClassNameProps } from 'types/utilities'
import { useTranslation } from 'react-i18next'

interface Props extends ClassNameProps {
  withContainer?: boolean
}

const ParentalConsent = ({ className, withContainer = false }: Props) => {
  const { t } = useTranslation('strRegister')
  const labels = useFormLabels()

  return (
    <section
      className={cx(className, styles.parentGuardianSection, { [styles.container]: withContainer })}
    >
      <InfoBox boxColor='yellow' className={styles.infoBox}>
        <h6 className={styles.infoBoxTitle}>{t('parentalConsent.infoBox.title')}</h6>
        <p>{t('parentalConsent.infoBox.info')}</p>
      </InfoBox>
      <p>{t('parentalConsent.helpText')}</p>
      <FormInputGroup
        label={labels.parentGuardianName}
        formikName={FormikNames.PARENT_GUARDIAN_NAME}
        classWrapper={styles.inputGroup}
      >
        <InputWTN
          id={FormikNames.PARENT_GUARDIAN_NAME}
          name={FormikNames.PARENT_GUARDIAN_NAME}
          className={cx(styles.commonTextInput, styles.input)}
        />
      </FormInputGroup>
      <FormInputGroup
        label={labels.parentGuardianEmail}
        formikName={FormikNames.PARENT_GUARDIAN_EMAIL}
        classWrapper={styles.inputGroup}
      >
        <InputWTN
          id={FormikNames.PARENT_GUARDIAN_EMAIL}
          name={FormikNames.PARENT_GUARDIAN_EMAIL}
          className={cx(styles.commonTextInput, styles.input)}
        />
      </FormInputGroup>
    </section>
  )
}

export default ParentalConsent
